export default {
  Consultations: 'Konsultacje',
  consultations: 'Konsultacji',
  consultation: 'Nowa konsultacja',
  'consultations.proposed_terms': 'Proponowane terminy',
  'consultations.calendar': 'Kalendarz',
  'consultations.screenSaves': 'Zapis Ekranu',
  'consultations.edit': 'Edycja konsultacji',
  'consultations.duration_tooltip':
    'Czas trwania konsultacji w godzinach, minutach, sekundach, dniach, tygodniach, miesiącach lub roku. Przykłady: 2 hours, 20 minutes, 1 day lub połączone 1 hour 30 minutes.',
};
